import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AuthShell from "./AuthShell";

export default function ResetPasswordPage() {
  const { resetPassword } = useAuth();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) { setError("A senha precisa ter no mínimo 8 caracteres."); return; }
    if (pw !== confirm) { setError("As senhas não coincidem."); return; }
    setLoading(true);
    try {
      await resetPassword(token, pw);
      setDone(true);
      setTimeout(() => nav("/login"), 2000);
    } catch (err) {
      setError(err?.response?.data?.detail || "Link inválido ou expirado.");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthShell title="Link inválido" subtitle="O endereço acessado está incompleto." footer={<Link to="/esqueci-senha" className="auth-link">Solicitar novo link</Link>}>
        <p className="text-center text-sm text-[#6B6B6B]" data-testid="reset-no-token">Solicite um novo link de redefinição.</p>
      </AuthShell>
    );
  }

  if (done) {
    return (
      <AuthShell title="Senha redefinida" subtitle="Pronto! Sua nova senha está ativa.">
        <p className="text-center text-sm text-[#6B6B6B]" data-testid="reset-done">Redirecionando para o login…</p>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title="Defina uma nova senha"
      subtitle="Escolha uma senha forte que você consiga lembrar."
      footer={<Link to="/login" className="auth-link" data-testid="link-to-login">Voltar para login</Link>}
    >
      <form onSubmit={onSubmit} className="space-y-5" data-testid="reset-form">
        <div>
          <label className="auth-label" htmlFor="pw">Nova senha (mín. 8 caracteres)</label>
          <input id="pw" type="password" required minLength={8} autoComplete="new-password"
            value={pw} onChange={(e) => setPw(e.target.value)}
            className="auth-input" data-testid="reset-password-input"/>
        </div>
        <div>
          <label className="auth-label" htmlFor="pw2">Confirmar nova senha</label>
          <input id="pw2" type="password" required minLength={8} autoComplete="new-password"
            value={confirm} onChange={(e) => setConfirm(e.target.value)}
            className="auth-input" data-testid="reset-confirm-input"/>
        </div>
        {error && <p className="text-sm text-[#B85050]" data-testid="reset-error">{error}</p>}
        <button type="submit" disabled={loading} className="auth-cta" data-testid="reset-submit-btn">
          {loading ? "Salvando…" : "Redefinir senha"}
        </button>
      </form>
    </AuthShell>
  );
}
